import styled from 'styled-components';

export const ChallengeReminder = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    background-color: #bbe6ef;
    padding: 15px 20px;
    margin-bottom: 25px;
    margin-top: 25px;
    border: 1px solid #0094f9;
    border-radius: 5px;
    grid-column-gap: 10px;

    @media screen and (max-width: 760px) {
        flex-direction: column;
        font-size: 12px;
    }
`;

export const Description = styled.div`
    display: flex;
    flex: 2.5;
    justify-content: center;
    align-items: center;
    gap: 20px;

    &p {
        font-family: 'Kanit';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        text-align: justify;
    }

    @media screen and (max-width: 990px) {
        justify-content: flex-end;
    }
`;

export const Button = styled.a`
    flex: 1;
    background: #ffd400;
    border-radius: 3px;
    border: none;

    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    margin-left: 80px;
    text-align: center;
    padding: 5px 12px;

    color: #ffffff;
    @media screen and (max-width: 990px) {
        margin: auto;
        margin-top: 20px;
        font-size: 10px;
    }
`;
